import { useNavigate } from '@solidjs/router'
import { Component, createSignal } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import AlertBag from '../../components/AlertBag'
import Loader from '../../components/Loader'
import { createAlertBagStore, setAlertBagError, setAlertBagSuccess } from '../../rx/store/AlertBag'
import { StoreMapBodySchema } from '../../backend_schemas'
import { saveToDisk } from '../../lib/core/disk/DiskFactory'
import { decodeStateSnapshot, encodeStateMessage } from '../../lib/core/engine/engineWasmCodec'
import { MAP_DEFAULT_HEIGHT, MAP_DEFAULT_WIDTH } from '../../lib/core/state/StateMap.type'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'
import { getDefaultStateMapDisk } from '../../lib/core/state/getDefaultStateMapDisk'
import { encodePersistedStateBytes } from '../../lib/core/state/persisted_state'
import valibotToErrorBag from '../../lib/valibot/valibotToErrorBag'
import { EngineInstance } from '../../engine_wrapper'

const CreateMapPage: Component = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  const handleCreate = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const defaultDisk = getDefaultStateMapDisk()
      const engine = await EngineInstance.create()
      let state = decodeStateSnapshot(engine.getBlankStateForEngineInit())

      // Set default dimensions and add second player to meet validation requirements
      state.width = MAP_DEFAULT_WIDTH
      state.height = MAP_DEFAULT_HEIGHT

      // Set disk type based on default
      state.map.disk = defaultDisk
      if (defaultDisk === StateMapDisk.IndexedDB) {
        state.online = null
      }

      state = decodeStateSnapshot(
        engine.appendMapEditorPlayer(encodeStateMessage(state))
      )

      const payload = parse(StoreMapBodySchema, { state: encodePersistedStateBytes(state) })

      // Save to appropriate disk
      let mapId: number
      const diskType = state.map.disk
      if (diskType === StateMapDisk.IndexedDB) {
        const response = await saveToDisk(state, StateMapDisk.IndexedDB)
        mapId = response.id
      } else {
        const response = await backendAxios.post('/st1/map', payload)
        mapId = response.data.id
      }

      setAlertBagSuccess(alertBag, 'Map created successfully')
      navigate(`/maps/edit?map_id=${mapId}&disk=${diskType}`)
    } catch (err) {
      console.log(valibotToErrorBag(err))
      console.error(err)
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div class="container mt-5">
      <h2>Create Map</h2>
      <AlertBag store={alertBag} />
      <form onSubmit={handleCreate}>
        <button type="submit" class="btn btn-primary" disabled={isLoading()}>
          {isLoading() ? <Loader /> : 'Create Map'}
        </button>
      </form>
    </div>
  )
}

export default CreateMapPage
